<script>
import TextInput from "./TextInput.vue";
import SelectInput from "./SelectInput.vue";
import TextareaInput from "./TextareaInput.vue";
import CheckboxInput from "./CheckboxInput.vue";
import DateInput from "./DateInput.vue";
import {
    AttendeeTypeEnum,
    DispositionEnum,
    EnglishFluencyEnum, FundingSourceEnum,
    GenderEnum, IndependentFundingEnum, PaymentMethodEnum, PaymentStatusEnum,
    PreferredMailingAddressEnum, PrivacyWaiverEnum, ResponseStatusEnum, SubmissionModeEnum, TravelArrangementsEnum
} from "../Enums/Enums";
import {iso31661} from "iso-3166";
export default {
    inheritAttrs: false,
    components: {
        TextInput,
        SelectInput,
        TextareaInput,
        CheckboxInput,
        DateInput,
    },
    props: {
        id: {
            type: String,
            default() {
                return `text-input-${this._uid}`
            },
        },
        type: {
            type: String,
            default: 'text',
        },
        rows: {
            type: Number,
            default: 1,
        },
        value: String|Number,
        label: String,
        error: String,
        inline: {
            type: Boolean,
            default() {
                return false;
            }
        },
        tableField: {
            type: String,
            required: true,
        },
    },
    computed: {
        fieldType() {
            switch (this.tableField) {
                case 'contact.current_member':
                case 'contact.subscribed':
                case 'contact.data_permissions':
                case 'contact.passport_scan':
                case 'attendee.invitation_in_english':
                case 'attendee.paper_interpretation':
                case 'attendee.paper_posted':
                case 'attendee.session_interpretation':
                case 'attendee.casual_interpretation':
                case 'attendee.biography_received':
                case 'attendee.photo_received':
                case 'attendee.paper_confirmed':
                case 'attendee.paper_received':
                case 'attendee.program_info_confirmed':
                case 'attendee.on_program':
                case 'attendee.translation_needed':
                case 'attendee.release_information':
                case 'attendee.copy_of_itinerary':
                case 'attendee.visa_help_needed':
                case 'attendee.consent_terms':
                case 'attendee.preorganized_panel':
                case 'attendee.nominated_by_iclrs':
                    return 'checkbox'
                case 'contact.passport_issue_date':
                case 'contact.passport_expiration_date':
                case 'contact.birthdate':
                case 'attendee.nomination_modification_date':
                case 'attendee.invitation_send_date':
                case 'attendee.invitation_delivery_date':
                case 'attendee.registration_date':
                case 'attendee.response_follow_up_date':
                case 'attendee.arrival_date':
                case 'attendee.return_date':
                case 'attendee.response_date':
                case 'attendee.program_info_confirmation_date':
                case 'attendee.visa_applied_for':
                case 'attendee.visa_received':
                case 'attendee.data_provided_to_travel_agent':
                case 'attendee.payment_date':
                case 'attendee.nomination_date':
                    return 'date'
                case 'contact.gender':
                case 'contact.english_fluency':
                case 'contact.contact_type_id':
                case 'contact.country_code':
                case 'contact.area_id':
                case 'contact.preferred_mailing_address':
                case 'attendee.attendee_type':
                case 'attendee.disposition':
                case 'attendee.funding_source':
                case 'attendee.payment_status':
                case 'attendee.payment_method':
                case 'attendee.submission_mode':
                case 'attendee.privacy_waiver':
                case 'attendee.travel_arrangements':
                case 'attendee.response_status':
                case 'attendee.independent_funding':
                    return 'select'
                default:
                    return 'text'
            }
        },
        selectOptions() {
            switch (this.tableField) {
                case 'contact.gender':
                    return GenderEnum
                case 'contact.english_fluency':
                    return EnglishFluencyEnum
                case 'contact.contact_type_id':
                    return this.$page.props.select_options.contact_types
                case 'contact.country_code':
                    return iso31661.map(function(country) {
                        return {
                            label: country.alpha2 + ' - ' + country.name,
                            value: country.alpha2
                        }
                    })
                case 'contact.area_id':
                    return this.$page.props.select_options.areas
                case 'contact.preferred_mailing_address':
                    return PreferredMailingAddressEnum
                case 'attendee.attendee_type':
                    return AttendeeTypeEnum
                case 'attendee.disposition':
                    return DispositionEnum
                case 'attendee.funding_source':
                    return FundingSourceEnum
                case 'attendee.payment_status':
                    return PaymentStatusEnum
                case 'attendee.payment_method':
                    return PaymentMethodEnum
                case 'attendee.submission_mode':
                    return SubmissionModeEnum
                case 'attendee.privacy_waiver':
                    return PrivacyWaiverEnum
                case 'attendee.travel_arrangements':
                    return TravelArrangementsEnum
                case 'attendee.response_status':
                    return ResponseStatusEnum
                case 'attendee.independent_funding':
                    return IndependentFundingEnum
                default:
                    return []
            }
        }
    }
}
</script>

<template>
    <select-input v-if="fieldType === 'select'" :value="value" @input="$emit('input', $event)" :error="error" :inline="inline" :label="label">
        <option :value="null" />
        <option v-for="opt in selectOptions" :key="opt.value" :value="opt.value" v-text="opt.label"></option>
    </select-input>
    <textarea-input v-else-if="fieldType === 'textarea'" :value="value" @input="$emit('input', $event)" :inline="inline" :rows="rows" :label="label" />
    <checkbox-input v-else-if="fieldType === 'checkbox'" :value="value" @input="$emit('input', $event)" :error="error" :inline="inline" :label="label" />
    <date-input v-else-if="fieldType === 'date'" :value="value" @input="$emit('input', $event)" :error="error" :type="type" :inline="inline" :label="label" />
    <text-input v-else type="type" :value="value" @input="$emit('input', $event)" :error="error" :inline="inline" :label="label" />
</template>

<style scoped>

</style>
